import { createContext } from 'react';

export type RouteContextType = {
  dispatch: (action: any) => void;
  dispatchAggregationAction: (action: any) => void;
  currentRouteState: any;
};
const RouteContext = createContext<RouteContextType>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  dispatch: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  dispatchAggregationAction: () => {},
  currentRouteState: {},
});

export default RouteContext;
